import React from 'react';

import Hero from '../../components/Hero/Hero';
import Page from '../../components/Page/Page';
import TrustedBy from '../../components/TrustedBy/TrustedBy';
import ClientSuccessStories from './ClientSuccessStories/ClientSuccessStories';
import KeyPoints from './KeyPoints/KeyPoints';
import SolutionWeProvide from './SolutionWeProvide/SolutionWeProvide';

const LookingForLocums = () => {
  return (
    <Page title="LocumSpace | Looking for Locums">
      <Hero
        imgSrc="/static/img/doctor-folds-arm.png"
        title="Find Compliant Healthcare Workers, Fast and Hassle-Free"
        description="We help healthcare providers connect with fully verified, compliant doctors and nurses quickly and securely.
Our platform ensures that every professional on our network holds valid licenses, up-to-date credentials, and meets regulatory standards, so you can fill shifts confidently and without delay."
      />
      <TrustedBy />
      <KeyPoints />
      <SolutionWeProvide />
      <ClientSuccessStories />
    </Page>
  );
};

export default LookingForLocums;
